<template>
  <div id="app">
  
    <transition
      mode="out-in"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      appear
    >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "APP",
};
</script>

<style lang="scss">
blockquote,
body,
dd,
dl,
dt,
fieldset,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
html,
iframe,
legend,
li,
ol,
p,
pre,
textarea,
ul {
  margin: 0;
  padding: 0;
}
.table_title {
  border: 1px solid #ebeef5;
  border-bottom: 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  height: 49px;
  line-height: 49px;
  background: #f1f6f9;
}
.main-header {
  background: #242f42 !important;
}
.main-header .navbar .navbar-custom-menu {
  color: #fff !important;
}
.main-header .logo {
  background: 2d2a30 !important;
}
.main-sidebar .vue-scrollbar .sidebar {
  background: #150f1a !important;
}
.main-sidebar.expandSide {
  background: #150f1a !important;
}
.el-menu {
  background: #150f1a !important;
}
.main-sidebar
  .vue-scrollbar
  .sidebar
  .el-menu-style
  .el-submenu
  .el-menu-item
  span {
  color: #fff;
}
.el-menu-item {
  color: #fff !important;
  border-left: 5px solid transparent;
}
.el-form-item {
  margin-bottom: 0px !important;
}
.main-sidebar
  .vue-scrollbar
  .sidebar
  .el-menu-style
  .el-submenu
  .el-menu-item.is-active
  span {
  color: #5dfe97 !important;
}
.el-menu-style {
  height: 570px;
}
.el-submenu__title * {
  color: #fff !important;
}
.el-menu-item.is-active {
  border-left: 5px solid #5dfe97;
  border-radius: 1px;
  color: #5dfe97 !important;
}
.el-dialog__body {
  padding: 20px !important;
}
.el-menu {
  // height:800px;
}
// .el-input__inner:not(.el-date-editor){
//      height: 50px !important;
//       background-color: #F5F5F5 !important ;
//       border: 1px solid #DDDDDD !important;
//       color: #999999 !important;
//   }
//   .el-form-item__label{
//     line-height: 50px !important;
//   }
html,
body,
#app {
  height: 100%;
  padding: 0;
  margin: 0;
}
.main-header .logo .logo-lg b {
  color: #fff !important;
}
.el-dropdown {
  //  color: #fff!important;
}
.main-header .navbar {
  background: #fff !important;
}
*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.main-sidebar .vue-scrollbar {
  background: #150f1a !important;
}
ul {
  width: auto !important;
}
a,
a:focus,
a:hover {
  color: inherit;
  cursor: pointer;
  text-decoration: none;
}
.el-dropdown:hover span {
  //  color: #5dfe97!important;
}
.el-button--goon.is-active,
.el-button--goon:active {
  background: #537fed;
  border-color: #537fed;
  color: #fff;
}

.el-button--goon:focus,
.el-button--goon:hover {
  background: #769dff;
  border-color: #769dff;
  color: #fff;
}
.el-button--goon {
  color: #fff;
  background-color: #6692ff;
  border-color: #6692ff;
}
.el-date-editor .el-range-separator {
  padding: 0 !important ;
  line-height: 32px !important;
  width: 5% !important;
}

.el-submenu__title * {
  padding-left: 4px !important;
}

.el-submenu__title {
  //  padding-left: 25px !important;
}
.el-dialog__footer {
  // text-align: center !important;
}
.el-menu-item [class^="el-icon-"] {
  margin-right: 10px !important;
}
.el-submenu__title [class^="el-icon-"] {
  margin-right: 10px !important;
}
.adv {
  width: 200px;
  position: absolute;
  bottom: 20px;
  left: 40px;
  z-index: 99999;
}
</style>
